import { ApiConstants } from '../utils/constants/ApiConstant'
import ApiService from '../utils/helper/ApiService'

export class ConfigDataService {
  apiService: ApiService
  apiEndpoints: any

  constructor() {
    this.apiService = new ApiService()
    this.apiEndpoints = ApiConstants.endpoints.filters
  }
  getConfigData(): Promise<any> {
    const url = `/config.json`
    return this.apiService.getFile(url)
  }
}
